module.exports = __webpack_public_path__ + "img/portrait-rechtsanwalt-christ.5227c6cc.jpg";